// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_A":"A_csr_pc_A__kccFP"};